import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const EmptyNote = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const DeleteBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${ColorV2.Blue4};
  font-size: 14px;
  padding: 4px 6px;
  border-radius: 6px;
  flex-shrink: 0;

  &:hover {
    color: ${ColorV2.NegativeRed};
    background: ${ColorV2.Blue6};
  }
`;

export const AddSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1.5px solid ${ColorV2.Blue6};
  flex-shrink: 0;
`;

export const AddSectionTitle = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue1};
`;

export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const FormLabel = styled.span`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const FormInput = styled.input`
  ${TypographyV2.b2}
  color: ${ColorV2.Blue1};
  background: ${ColorV2.White};
  border: 1.5px solid ${ColorV2.Blue5};
  border-radius: 10px;
  padding: 8px 12px;
  width: 100%;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: ${ColorV2.ElectricBlue};
  }

  &:hover {
    border-color: ${ColorV2.Blue4};
  }

  &[type="number"]::-webkit-inner-spin-button,
  &[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`;

export const FormRow = styled.div`
  display: flex;
  gap: 10px;
`;

export const DatePickerWrapper = styled.div`
  /* Suppress the bottom message/hint space the DatePicker reserves by default */
  > div {
    margin-bottom: 0;
  }
`;

export const AddButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
`;
